// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_Ihf","cls2":"Unibrow-cls2_R1b Unibrow-cls1_Ihf"};